module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Startup Application Tracking")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.checkStatus($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "placeholder": "10 Digit Mobile",
      "id": "mobile",
      "required": "",
      "minlength": "10",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "keyup": function($event) {
        _vm.onChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.show == true) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email Address",
      "id": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        _vm.showB()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showButton == true) ? _c('input', {
    staticClass: "btn btn-primary btn-block button",
    attrs: {
      "type": "submit",
      "value": "Check Status"
    }
  }) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.submitLoader) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    staticStyle: {
      "font-size": "24px"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showStatus == true && _vm.showTable == true) ? _c('table', {
    staticClass: "table .table-bordered .table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.array), function(val, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.startup))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.fname) + " " + _vm._s(val.lname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.mobile))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.reason))]), _vm._v(" "), _c('td', [(val.status == 'Selected') ? _c('p', [_vm._v("\n                      Congratulations! You will receive an email with further details.\n                    ")]) : _vm._e(), _vm._v(" "), (val.status == 'Shortlisted') ? _c('p', [_vm._v("\n                      Congratulations! Your application is shortlisted and you will receive an email with further details for the next round of scrutiny if you have not received already.\n                    ")]) : _vm._e(), _vm._v(" "), (val.status == 'Under Review') ? _c('p', [_vm._v("\n                      It usually takes up to 30-45 working days\n                      to review your application. Please allow\n                      adequate time for review and check back later\n                      for an updated status on your application.\n                    ")]) : _vm._e(), _vm._v(" "), (val.status == 'Decision Taken') ? _c('p', [_vm._v("\n                      A decision on your application has been taken\n                      and conveyed to you, either in person,\n                      or through an email.\n                    ")]) : _vm._e(), _vm._v(" "), (val.status == 'Not Selected') ? _c('p', [_vm._v("\n                      Your application was reviewed by a competent authority and was not found suitable for startup support at GUSEC. Due to the large volume of applications, we are unable to provide individual feedback on all applications via this platform. However, you are free to get in touch with us if you wish to get clarification on this decision taken on your application. You are also most welcome to apply for a different or an updated version of your idea using the Apply button on the GUSEC website.\n                    ")]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showNotFound == true) ? _c('p', [_vm._v("\n              Sorry, record not found."), _c('br'), _c('br'), _vm._v("\n\n              Are you entering the right phone number and the"), _c('br'), _vm._v("\n              email address that you submitted at the time of"), _c('br'), _vm._v("\n              application at GUSEC?"), _c('br'), _c('br'), _vm._v("\n\n              If not, application tracking will not work."), _c('br'), _vm._v("\n              Furthermore, please note it may take up to"), _c('br'), _vm._v("\n              3 working days after your submitting an application"), _c('br'), _vm._v("\n              for our application tracking system to work."), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.array), function(val) {
    return (_vm.showTable == false) ? [(_vm.showStatus == true) ? _c('h3', [_vm._v(_vm._s(val.fname) + " " + _vm._s(val.lname))]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Selected') ? _c('p', [_vm._v("\n              Application Status: " + _vm._s(val.status)), _c('br'), _c('br'), _vm._v("\n              Congratulations! You will receive an email with further details.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Shortlisted') ? _c('p', [_vm._v("\n              Application Status: " + _vm._s(val.status)), _c('br'), _c('br'), _vm._v("\n              Congratulations!"), _c('br'), _vm._v("\n              Your application is shortlisted and you will"), _c('br'), _vm._v("\n              receive an email with further details for the"), _c('br'), _vm._v("\n              next round of scrutiny if you have not received already.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Under Review') ? _c('p', [_vm._v("\n              Application Status: " + _vm._s(val.status)), _c('br'), _c('br'), _vm._v("\n              It usually takes up to 30-45 working days "), _c('br'), _vm._v("\n              to review your application. Please allow "), _c('br'), _vm._v("\n              adequate time for review and check back later"), _c('br'), _vm._v("\n              for an updated status on your application.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Decision Taken') ? _c('p', [_vm._v("\n              Application Status: " + _vm._s(val.status)), _c('br'), _c('br'), _vm._v("\n              A decision on your application has been taken"), _c('br'), _vm._v("\n              and conveyed to you, either in person,"), _c('br'), _vm._v("\n              or through an email.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Not Selected') ? _c('p', [_vm._v("\n              Application Status: " + _vm._s(val.status) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Not Selected' && val.reason) ? _c('p', [_vm._v("\n              Reason: " + _vm._s(val.reason) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Not Selected') ? _c('p', [_vm._v("\n              Your application was reviewed by a competent "), _c('br'), _vm._v("\n              authority and was not found suitable for startup"), _c('br'), _vm._v("\n              support at GUSEC."), _c('br'), _vm._v("\n              Due to the large volume of applications, we are unable"), _c('br'), _vm._v("\n              to provide individual feedback on all applications "), _c('br'), _vm._v("\n              via this platform. "), _c('br'), _vm._v("\n              However, you are free to get in touch with us if you wish"), _c('br'), _vm._v("\n              to get clarification on this decision taken on your application."), _c('br'), _vm._v("\n              You are also most welcome to apply for a different or an"), _c('br'), _vm._v("\n              updated version of your idea using the Apply button on the GUSEC website.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showNotFound == true) ? _c('p', [_vm._v("\n              Sorry, record not found."), _c('br'), _c('br'), _vm._v("\n\n              Are you entering the right phone number and the"), _c('br'), _vm._v("\n              email address that you submitted at the time of"), _c('br'), _vm._v("\n              application at GUSEC?"), _c('br'), _c('br'), _vm._v("\n\n              If not, application tracking will not work."), _c('br'), _vm._v("\n              Furthermore, please note it may take up to"), _c('br'), _vm._v("\n              3 working days after your submitting an application"), _c('br'), _vm._v("\n              for our application tracking system to work."), _c('br')]) : _vm._e()] : _vm._e()
  }), _vm._v(" "), _c('br')], 2)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Startup")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Reason")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Comments")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-auto"
  }, [_c('p', {
    attrs: {
      "id": "message"
    }
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" This application tracking system is only for applications made for startup support (incubation) using the application page at "), _c('a', {
    attrs: {
      "href": "https://gusec.edu.in/apply",
      "target": "_blank"
    }
  }, [_vm._v("https://gusec.edu.in/apply")]), _vm._v(". If you have applied for accelerateBHARAT, CIF, herSTART, STARTfest or any other such program of GUSEC, application tracking will not work for those applications. For any queries, please write to us at contact@gusec.edu.in.\n              ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://gusec.edu.in/",
      "target": "_blank"
    }
  }, [_vm._v("GUSEC Website ")]), _vm._v("| "), _c('a', {
    attrs: {
      "href": "https://gusec.edu.in/apply/",
      "target": "_blank"
    }
  }, [_vm._v("Apply for Startup at GUSEC")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Powered By:"), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.easilydone.in/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "id": "image",
      "src": "/static/img/easilydone.png"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8a21100"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 159
// module chunks = 1